<div class="flex h-full flex-col gap-6 p-6">
  <!-- Header Section -->
  <div class="flex items-center justify-between gap-3">
    <div class="flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-sky-100">
        <dojo-icon [icon]="'file-lines'" [size]="20" class="text-sky-600" />
      </div>
      <div>
        <h2 class="text-lg font-semibold text-gray-900">Study Notes Editor</h2>
        <p class="text-sm text-gray-500">
          Create and edit your study notes with rich text formatting. Changes are saved automatically.
        </p>
      </div>
    </div>
    <dojo-button [fill]="'outline'" (click)="loadSampleContent()">
      <dojo-icon [icon]="'flask'" class="mr-2" />
      <span>Load Sample Content</span>
    </dojo-button>
  </div>

  <div class="flex flex-1 flex-col gap-4 overflow-hidden">
    <dojo-textarea-input
      [formCtrl]="textareaControl"
      [label]="'Raw content'"
      [placeholder]="'Type or paste content here to update the editor...'"
      [autoResize]="true"
      [autoResizeMinRows]="4"
      [autoResizeMaxRows]="10"
    ></dojo-textarea-input>

    <div class="flex min-h-0 flex-1 gap-4">
      <div
        #scrollableContainerRef
        class="flex-1 overflow-auto rounded-lg border border-neutral-200 bg-white shadow-sm dark:bg-black"
      >
        <dojo-tiptap-editor-wrapper
          #editorWrapper
          class="h-full"
          [valueControl]="editorControl"
          [editorOptions]="editorOptions()"
          [slashMenuItems]="slashMenuItems()"
          [scrollableParent]="scrollableContainer()"
        />
      </div>

      @if (tableOfContentData().length > 0) {
        <aside
          class="toc-sidebar w-64 shrink-0 rounded-lg border border-neutral-200 bg-neutral-50 p-4 dark:bg-neutral-900"
        >
          <h3 class="mb-3 text-sm font-semibold text-neutral-700 dark:text-neutral-300">
            <dojo-icon [icon]="'list'" [size]="14" class="mr-2" />
            Table of Contents
          </h3>
          @if (editor(); as editor) {
            <dojo-tiptap-table-of-contents
              [tableOfContentData]="tableOfContentData()"
              [editor]="editor"
              [scrollableParent]="scrollableContainer()"
            />
          }
        </aside>
      }
    </div>
  </div>
</div>
